var exports = {
  "v": "x804f0401--1be00c--tabs",
};

module.exports = exports;
